export const CROSSING_DETAIL_RENDER_CONFIG = Object.freeze({
  crossingHalfLengthM: 2.35,
  tactileDepthM: 0.62,
  tactileWidthM: 2.2,
  kerbRampDepthM: 0.9,
  refugeIslandLengthM: 3.4,
  refugeIslandWidthM: 1.25,
  raisedTableLengthM: 5.4,
  raisedTableLiftM: 0.045,
  surfaceLiftM: 0.022,
  cycleBoundaryOffsetM: 1.35,
  cycleDashLengthM: 0.65,
  cycleDashGapM: 0.55,
  cycleLineWidthM: 0.12,
});
